import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';

import {OBJECT_TYPE_ICONS} from '../constants';
import {ObjectCardProps} from '../types';
import {buildObjectVersionRoute, formatObjectCardDate} from '../utils';

export const ObjectCard: React.FC<ObjectCardProps> = ({
  name,
  versionIndex,
  createdAt,
  type,
  entityName,
  projectName,
  description,
  digest,
}) => {
  const iconName = OBJECT_TYPE_ICONS[type] ?? 'info';
  const formattedDate = formatObjectCardDate(createdAt);

  const route = useMemo(() => {
    // Evaluations aren't displayed as objects, fallback to weave home
    if (type !== 'model' && type !== 'dataset') {
      return `/${entityName}/${projectName}/weave`;
    }
    return buildObjectVersionRoute(name, digest, type, entityName, projectName);
  }, [name, digest, type, entityName, projectName]);

  return (
    <Tailwind>
      <Link
        to={route}
        className="flex flex-col gap-8 rounded-lg border border-moon-250 bg-white p-16 hover:border-moon-300 hover:bg-moon-25">
        <div className="flex items-start justify-between gap-8">
          <div className="min-w-0 flex-1">
            <div className="truncate font-semibold text-moon-900" title={name}>
              {name}
            </div>
          </div>
          <Icon
            name={iconName}
            width={16}
            height={16}
            className="flex-shrink-0 text-moon-400"
          />
        </div>

        <div className="flex items-center justify-between gap-8 text-xs">
          <span className="font-medium text-moon-500">v{versionIndex}</span>
          {createdAt && <span className="text-moon-400">{formattedDate}</span>}
        </div>

        {description && (
          <p className="line-clamp-2 text-xs text-moon-600">{description}</p>
        )}
      </Link>
    </Tailwind>
  );
};
